<template>
  <div class="textarea-entry-component question-type-component">
    <div class="hint-text" v-if="$props.question.hint">{{ $props.question.hint.get() }}</div>
    <div class="textarea-field-wrapper">
      <TextfieldComponent v-for="(option, i) in $props.question.options" v-model="submission['root'][`${option.value}`]" :label="option.name.get()" autogrow />
    </div>
  </div>
</template>

<script lang="ts" setup>
import QualityMentoringFormQuestion from '../../models/QualityMentoringFormQuestion';

const props = defineProps({
  question: QualityMentoringFormQuestion,
  submission: Object
})

function clear() {
  props.question.options.forEach((option) => {
    delete props.submission['root'][option.value];
  })
}

defineExpose({
  clear
})
</script>
